<!-- Buffer -->
<template>
    <div class="OutputBuffer">
      <div class="BackFile">
        <div class="SelectBackFile">
          <div class="ReplacementVideo">
            {{$t('lang.ReplacementVideo')}}
          </div>
          <div class="FileSelect">
            <!-- <public-file-select
            :SelectType="1"
            :SelectValue="{
              fileId: ReplacementVideo.fileId,
              fileName: ReplacementVideo.tname,
            }"
            :AppendBody="false"
            @fileSelectChange="
              pitchOnFile => fileSeleteChange(pitchOnFile, 1)
           "></public-file-select> -->
           <public-multiple-select
            v-if="configParams"
            :SelectType="2"
            :configParams="configParams"
            :SelectValue="{
              fileId: ReplacementVideo.fileId,
              fileName: ReplacementVideo.fileName,
            }"
            :disabled="repalceLoading"
            @MediaLiveSelectChange="fileSeleteChange"
          >
          </public-multiple-select>
          </div>
        </div>
        <div class="VideoSupport">
          <div class="VideoSupportWrap">
            <p>{{$t('lang.VideoSupport')}}</p>
            <p>{{$t('lang.Resolution')}}: 1920×1080</p>
            <p>{{$t('lang.AudioSampleRate')}}: 48000HZ</p>
            <p>{{$t('lang.NoSupportFile')}}</p>
          </div>
        </div>
      </div>
      <div class="errorTime">
        <div class="ReactionTime">
          {{$t('lang.ReactionTime')}}
          <div class="questionMark" @click.stop="()=>{}">
            <el-tooltip placement="top">
              <div slot="content" style="width:250px"><p style="margin: 0px;">{{$t('lang.ReactionTimeTip')}}</p></div>
              <i class="iconfont icon-help2" style="color:#666666;margin-left:10px;transform: translateY(1px);"></i>
            </el-tooltip>
          </div>
        </div>
        <div class="TimeBar">
          <div class="BufferSlider">
              <el-slider
                v-model.number="ReplacementVideo.bufferSize"
                show-input
                :show-input-controls="false"
                @change="changeReactionTime"
                :max="300"
                :min="2"
              ></el-slider>
            <span class="unit">{{$t('lang.AbbreviationS')}}</span>
          </div>
        </div>
      </div>
      <div class="ReviewData">
        <div class="ReviewDataWrap" v-if="ReviewDataList.length">
          <div class="ReviewList" v-for="(item, index) in ReviewDataList" :key="index">
            <div class="DataName">
              {{item.sourceName}}
            </div>
            <div class="Time">
              {{getTransitionTime(item.switchTime)}}
            </div>
          </div>
        </div>
        <div class="NoReviewData" v-else>
          <div class="NoData">
            {{$t('lang.noData')}}
          </div>
          <p>{{$t('lang.CensorData')}}</p>
        </div>
      </div>
      <div class="PrevieweCensorship">
        <div class="CensorshipPage">{{$t('lang.CensorshipPage')}}</div>
        <div class="CensorshipUrl">
          <div class="url" :title="ReplacementVideo.url" @click="jumptoView">{{ReplacementVideo.url}}</div>
          <div class="copy" @click="CopyPreviewUrl(ReplacementVideo.url)">{{$t('lang.Copy')}}</div>
        </div>
      </div>
    </div>
</template>

<script>
import Outil from '@/assets/js/utils.js'
import toTips from '@/assets/js/toTipsObj'
import { mapState, mapActions, mapMutations } from 'vuex'
import PublicMultipleSelect from '@/components/select/PublicMultipleSelect.vue'
import Bus from '@/assets/js/vueBus.js'
import {
  SourceConfigParams
} from '@/assets/js/temConfig.js'
export default {
  data () {
    return {
      ReplacementVideo: {
        fileId: '',
        fileName: '',
        bufferSize: 2,
        url: ''
      },
      ReviewDataList: [],
      // media,模板选择配置
      configParams: {
        List: {
          media: {}
        },
        search: {
          Params: {}
        }
      },
      repalceLoading: false
    }
  },
  components: {
    PublicMultipleSelect
  },
  created () {
    this.getOutputBufferRecord()
    this.getOutputBuffer()
  },
  mounted () {
    const programId = this.$BehaviorSyns.getProgramId()
    const RegionInfo = this.$BehaviorSyns.getRegionBucket()
    this.configParams = {
      List: {
        Media: SourceConfigParams(programId, RegionInfo.bucket).Media
      },
      search: SourceConfigParams(programId, RegionInfo.bucket).search
    }
    console.log(this.configParams)
  },
  computed: mapState({
    StateObj: (state) => state
  }),
  watch: {
    'StateObj.BehaviorChange' (data) {
      if (data.action == 'updateOutputBufferPage') {
        this.getOutputBufferRecord()
      }
    }
  },
  methods: {
    changeReactionTime (num) {
      this.axios.post(Outil.getUrl('/outputBuffer/setBufferSize'),
        { programId: this.$BehaviorSyns.getProgramId(), bufferSize: num }
      ).then((res) => {
        if (res.data.errorCode == '0x0') {
          const result = res.data.result
          console.log('wewewe')
          this.$message.success(this.$t('lang.success'))
          Bus.$emit('bufferMessage', result)
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
    },
    jumptoView () {
      window.open(this.ReplacementVideo.url, '_blank')
    },
    getOutputBufferRecord () {
      this.axios.post(Outil.getUrl('/outputBuffer/pageOutputBufferRecord'),
        {
          programId: this.$BehaviorSyns.getProgramId(),
          pageNum: 1,
          pageSize: 10000
        }
      ).then((res) => {
        if (res.data.errorCode == '0x0') {
          const result = res.data.result
          this.ReviewDataList = result.list
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
    },
    getOutputBuffer () {
      this.repalceLoading = true
      this.axios.post(Outil.getUrl('/outputBuffer/getOutputBufferByProgramId'),
        { programId: this.$BehaviorSyns.getProgramId() }
      ).then((res) => {
        if (res.data.errorCode == '0x0') {
          const result = res.data.result
          this.repalceLoading = false
          // Bus.$emit('bufferMessage', result)
          this.ReplacementVideo.fileId = result.sourceId
          this.ReplacementVideo.fileName = result.sourceName
          this.ReplacementVideo.bufferSize = result.bufferSize
          const { urlInfo } = JSON.parse(localStorage.getItem('channelInitConfig'))
          const { playoutUrl } = urlInfo
          this.ReplacementVideo.url = `${playoutUrl}/#/ob?ProgramId=${this.$BehaviorSyns.getProgramId()}`
        } else {
          this.repalceLoading = false
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {
        this.repalceLoading = false
      })
    },
    // 选择文件
    fileSeleteChange (data) {
      this.repalceLoading = true
      this.axios.post(Outil.getUrl('/outputBuffer/setSourceId'),
        { programId: this.$BehaviorSyns.getProgramId(), sourceId: data.sourceId }
      ).then((res) => {
        if (res.data.errorCode == '0x0') {
          const result = res.data.result
          this.ReplacementVideo.fileId = result.sourceId
          this.ReplacementVideo.fileName = result.sourceName
          this.repalceLoading = false
          this.$message.success(this.$t('lang.success'))
        } else {
          this.getOutputBuffer()
          this.repalceLoading = false
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {
        this.getOutputBuffer()
        this.repalceLoading = false
      })
    },
    // 转换显示时间
    getTransitionTime (Time) {
      return Outil.TransitionCurrentTime(new Date(Time))
    },
    // 复制预览链接
    CopyPreviewUrl (url) {
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', url)
      input.select()
      document.execCommand('copy')
      if (document.execCommand('copy')) {
        this.$message({ type: 'success', message: 'Copy success' })
      }
      document.body.removeChild(input)
    }
  }
}
</script>

<style scoped lang="less">
.OutputBuffer{
  color: #DBDBDB;
  position: relative;
  height: 100%;
  .BackFile{
    .SelectBackFile{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 12px;
      .ReplacementVideo{
        width: 30%;
        font-size: 14px;
        color: #DBDBDB;
        text-align: left;
      }
      ::v-deep .FileSelect{
        width: 65%;
        text-align: left;
        .el-select{
          width: 100%;
          .el-select-dropdown{
            width: 100%;
          }
          .el-input__inner{
            background: #252525;
            height: 32px;
          }
        }
      }
    }
    .VideoSupport{
      display: flex;
      justify-content: flex-end;
      margin-top: 8px;
      margin-bottom: 20px;
      .VideoSupportWrap{
        width: 65%;
        p {
          margin: 0;
          text-align: left;
          font-size: 12px;
          line-height: 14px;
          color: #777777;
        }
      }
    }
  }
  .errorTime{
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    padding-bottom: 12px;
    border-bottom: 1px solid #666;
    .ReactionTime{
      width: 30%;
      display: flex;
    }
    ::v-deep .TimeBar{
      position: relative;
      width: 65%;
      .el-slider{
        .el-slider__runway.show-input{
          margin-right: 80px;
          margin-left: 6px;
          .el-slider__button-wrapper{
           z-index: 0;
          }
        }
        .el-input-number {
          width: 64px;
          .el-input__inner{
            width: 64px;
            height: 32px;
            padding: 0 8px;
            text-align: left;
            border: none;
            background: #252525;
          }
        }
      }
      .unit{
        position: absolute;
        right: 10px;
        top: 10px;
        color: #777777;
        font-size: 12px;
      }
    }
  }
  .ReviewData{
    height: calc(100% - 260px);
    overflow-y: auto;
    text-align: left;
    font-size: 14px;
    padding-top: 16px;
    .ReviewDataWrap{
      .ReviewList{
        margin-bottom: 16px;
        .DataName{
          color: #DBDBDB
        }
        .Time{
          color: #999999;
          margin-top: 3px;
        }
      }
    }
    .NoReviewData{
      text-align: center;
      p{
        font-size: 12px;
        color: #777777;
      }
    }
  }
  .PrevieweCensorship{
    position: absolute;
    bottom: 0;
    left: 0px;
    width: 100%;
    height: 56px;
    border-top: 1px solid #666;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    text-align: left;
    .CensorshipPage{
      width: 30%;
    }
    .CensorshipUrl{
      width: 65%;
      display: flex;
      .url{
        width: 80%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #44A4FD;
        cursor: pointer;
      }
      .copy{
        width: 20%;
        text-align: right;
        color: #33AB4F;
        cursor: pointer;
      }
    }
  }
}

</style>
